export default __webpack_public_path__ + "static/SectionTwo_01_03-3b932abbbb523d54091cb86ea0edfb70.png";